import React, { useState, createContext, useContext } from 'react';
export type UserRole = 'guest' | 'fornitore' | 'manutenzione' | 'host';
interface AuthContextType {
  userRole: UserRole;
  login: (role: UserRole) => void;
  logout: () => void;
  isAuthenticated: boolean;
}
const AuthContext = createContext<AuthContextType | undefined>(undefined);
export function AuthProvider({
  children
}: {
  children: ReactNode;
}) {
  const [userRole, setUserRole] = useState<UserRole>('guest');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const login = (role: UserRole) => {
    setUserRole(role);
    setIsAuthenticated(true);
  };
  const logout = () => {
    setUserRole('guest');
    setIsAuthenticated(false);
  };
  return <AuthContext.Provider value={{
    userRole,
    login,
    logout,
    isAuthenticated
  }} data-id="element-617">
      {children}
    </AuthContext.Provider>;
}
export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}